import React from 'react';
import Services from '../components/Services';
import FeaturedPosts from '../components/FeaturedPosts';
import Portfolio from '../components/Portfolio';
import Strategy from '../components/Strategy';
import Cta from '../components/Cta';
import Team from '../components/Team';
import Layout from '../components/layout/Layout';
import HeroImage from '../svg/HeroImage';
import { Fade } from 'react-reveal';

export default () => (
  <Layout>
    <section className="pt-10">
      <div className="container mx-auto">
        <div className="text-center lg:text-center">
          <Fade bottom duration={500}>
            <h1 className="text-5xl lg:text-7xl text-primary font-bold leading-none">
              Con·sult·ant
            </h1>
          </Fade>
          <Fade bottom delay={700} duration={500}>
            <h1 className=" italic text-3xl lg:text-3xl font-display text-gray-400 pt-3 leading-none">
              /kənˈsəltnt/ - Noun
            </h1>
            <h2 className="text-2xl lg:text-4xl text-primary pt-3 font-regular leading-tight">
              A person who gives professional or expert advice.
            </h2>
          </Fade>
        </div>
      </div>

      <div className="mt-8 md:mt-14 container mx-auto">
        <div className="mx-auto w-4/6">
          <Fade In delay={300} duration={1000}>
            <HeroImage />
          </Fade>
        </div>
      </div>
    </section>
    <section id="services">
      <Fade In duration={1000}>
        <Services />
      </Fade>
    </section>
    <svg className="-mb-18" fill="#0f3f9d" viewBox="0 0 1440 120">
      <path d="M1440,21.2101911 L1440,120 L0,120 L0,21.2101911 C120,35.0700637 240,42 360,42 C480,42 600,35.0700637 720,21.2101911 C808.32779,12.416393 874.573633,6.87702029 918.737528,4.59207306 C972.491685,1.8109458 1026.24584,0.420382166 1080,0.420382166 C1200,0.420382166 1320,7.35031847 1440,21.2101911 Z" />
    </svg>
    <Strategy />
    <section id="about">
      <Fade In duration={1000}>
        <Team />
      </Fade>
    </section>
    <section id="portfolio">
      <Fade In duration={1000}>
        <p className="mt-20 text-center text-gray-700 text-5xl leading-11 font-extrabold tracking-tight">
          Trusted by
        </p>
        <Portfolio />
      </Fade>
    </section>
    <section id="blog">
      <Fade In duration={1000}>
        <FeaturedPosts />
      </Fade>
    </section>

    <Fade In duration={1000}>
      <Cta />
    </Fade>
  </Layout>
);

/*<div className="grid mt-8 md:mt-14 container mx-auto md:flex">
<div className="order-last md:order-first sm:w-full md:w-1/3 text-center md:text-left md:pr-8">
  <Fade In duration={3000}>
    <h2 className="text-3xl lg:text-3xl italic text-gray-400 pt-2 leading-none">Noun</h2>

    <h2 className="text-2xl lg:text-2xl text-primary pt-4 font-regular leading-tight">
      A person who gives professional or expert advice:
    </h2>

    <h4 className="mt-2 md:ml-16 text-xl lg:text-xl text-gray-400 pt-4 font-regular leading-tight">
      1. A consultant on business methods.
    </h4>

    <h4 className="mt-2 md:ml-16 text-xl lg:text-xl text-gray-400 pt-4 font-regular leading-tight">
      2. A person who consults come one or something.
    </h4>

    <h4 className="mt-2 md:ml-16 text-xl lg:text-xl text-gray-400 pt-4 font-regular leading-tight">
      3. Your dedicated member of Consult FGC.
    </h4>
  </Fade>
</div>

<div className="sm:w-full md:w-4/6 md:ml-6 text-center">
  <Fade In delay={300} duration={1000}>
    <HeroImage />
  </Fade>
</div>
</div>
</section>
<section id="services">
<Fade In duration={1000}>
<Services />
</Fade>
</section>
<svg className="-mb-18" fill="#0f3f9d" viewBox="0 0 1440 120">
<path d="M1440,21.2101911 L1440,120 L0,120 L0,21.2101911 C120,35.0700637 240,42 360,42 C480,42 600,35.0700637 720,21.2101911 C808.32779,12.416393 874.573633,6.87702029 918.737528,4.59207306 C972.491685,1.8109458 1026.24584,0.420382166 1080,0.420382166 C1200,0.420382166 1320,7.35031847 1440,21.2101911 Z" />
</svg>
<Strategy />
<section id="about">
<Fade In duration={1000}>
<Team />
</Fade>
</section>
<section id="portfolio">
<Fade In duration={1000}>
<Portfolio />
</Fade>
</section>
<section id="blog">
<Fade In duration={1000}>
<FeaturedPosts />
</Fade>
</section>

<Fade In duration={1000}>
<Cta />
</Fade>
</Layout>
);*/
